import DomainLogo from './domain-logo';
export default DomainLogo;